import React, { useState, useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import { PDFExport } from '@progress/kendo-react-pdf';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import CurrencyFormat from 'react-currency-format';

import Table from '../../components/Table';
import Logo1 from '../../icons/icon-pdf-logo.png';

import {
  getData,
  GET_LOAD_DETAILS_URL,
  GET_PAYMENT_STATUS_URL,
} from '../../utils/api';

const SettlementPDF = (props) => {
  let ref = React.createRef();
  let componentRef = React.createRef();
  const loadData = props.itemData;

  const receivedDate = new Date(loadData?.receivedDate);
  const metalDueDate = new Date(loadData?.metalDueDate);

  const [product, setProduct] = useState({
    ptMetalReturn: {},
    pdMetalReturn: {},
    rhMetalReturn: {},
    ptRefiningCharge: {},
    pdRefiningCharge: {},
    rhRefiningCharge: {},
    advInvoice: {},
    intInvoice: {},
    tc: {},
    sc: {},
    af: {},
    espi: {},
    fi: {},
    totalCharges: '',
    totalSettlementAmount: '',
  });

  useEffect(() => {
    if (loadData) {
      setProduct({
        ...product,
        ptMetalReturn: loadData?.ptMetalReturn || {},
        pdMetalReturn: loadData?.pdMetalReturn || {},
        rhMetalReturn: loadData?.rhMetalReturn || {},
        ptRefiningCharge: loadData?.ptRefiningCharge || {},
        pdRefiningCharge: loadData?.pdRefiningCharge || {},
        rhRefiningCharge: loadData?.rhRefiningCharge || {},
        advInvoice: loadData?.advInvoice || {},
        intInvoice: loadData?.intInvoice || {},
        tc: loadData?.tc || {},
        sc: loadData?.sc || {},
        af: loadData?.af || {},
        espi: loadData?.espi || {},
        fi: loadData?.fi || {},
        totalCharges: loadData?.totalCharges || '',
        totalSettlementAmount: loadData?.totalSettlementAmount || '',
      });
    }
  }, [loadData]);

  const cellStyle = {
    border: '1px solid rgba(0, 0, 0, 0.4)',
    padding: '2px',
    textAlign: 'center',
    fontSize: 10,
  };

  const productData = {
    header: [
      'Product',
      'Charge / Return Type',
      'Invoice Number',
      'Advance Date',
      'Total Ounces',
      'Charge/ Return ($ %)',
      'Quantity',
      'Avg Price',
      'Charge/Return',
    ],
    data: [
      [
        'PT',
        'Metal Return %',
        'ptMetalReturn_invoiceNo_text',
        'ptMetalReturn_advanceDate_date',
        'ptMetalReturn_totalOunces_number_nonInput',
        'ptMetalReturn_chargeReturnPerc_number',
        'ptMetalReturn_quantity_number_nonInput',
        'ptMetalReturn_avgPrice_number_nonInput',
        'ptMetalReturn_chargeReturn_number_nonInput',
      ],
      [
        'PD',
        'Metal Return %',
        'pdMetalReturn_invoiceNo_text',
        'pdMetalReturn_advanceDate_date',
        'pdMetalReturn_totalOunces_number_nonInput',
        'pdMetalReturn_chargeReturnPerc_number',
        'pdMetalReturn_quantity_number_nonInput',
        'pdMetalReturn_avgPrice_number_nonInput',
        'pdMetalReturn_chargeReturn_number_nonInput',
      ],
      [
        'RH',
        'Metal Return %',
        'rhMetalReturn_invoiceNo_text',
        'rhMetalReturn_advanceDate_date',
        'rhMetalReturn_totalOunces_number_nonInput',
        'rhMetalReturn_chargeReturnPerc_number',
        'rhMetalReturn_quantity_number_nonInput',
        'rhMetalReturn_avgPrice_number_nonInput',
        'rhMetalReturn_chargeReturn_number_nonInput',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        'Metal Return Value ($)',
        '',
        'metalReturn_chargeReturn_number_nonInput',
      ],
      [
        'PT',
        'Refining Charge',
        '',
        '',
        '',
        'ptRefiningCharge_chargeReturnPerc_number',
        'ptRefiningCharge_quantity_number_nonInput',
        '',
        'ptRefiningCharge_chargeReturn_number_nonInput',
      ],
      [
        'PD',
        'Refining Charge',
        '',
        '',
        '',
        'pdRefiningCharge_chargeReturnPerc_number',
        'pdRefiningCharge_quantity_number_nonInput',
        '',
        'pdRefiningCharge_chargeReturn_number_nonInput',
      ],
      [
        'RH',
        'Refining Charge',
        '',
        '',
        '',
        'rhRefiningCharge_chargeReturnPerc_number',
        'rhRefiningCharge_quantity_number_nonInput',
        '',
        'rhRefiningCharge_chargeReturn_number_nonInput',
      ],
      [
        'ADV',
        'Invoice',
        '',
        '',
        '',
        '',
        'advInvoice_quantity_number',
        '',
        'advInvoice_chargeReturn_number',
      ],
      [
        'INT',
        'Invoice',
        '',
        '',
        '',
        'intInvoice_chargeReturnPerc_number',
        'intInvoice_quantity_number',
        '',
        'intInvoice_chargeReturn_number_nonInput',
      ],
      [
        'TC',
        'Treatment Charge',
        '',
        '',
        '',
        'tc_chargeReturnPerc_number',
        'tc_quantity_number',
        '',
        'tc_chargeReturn_number_nonInput',
      ],
      [
        'SC',
        'Sample Shipping',
        '',
        '',
        '',
        'sc_chargeReturnPerc_number',
        'sc_quantity_number',
        '',
        'sc_chargeReturn_number_nonInput',
      ],
      [
        'AF',
        'Assay Fee',
        '',
        '',
        '',
        'af_chargeReturnPerc_number',
        'af_quantity_number',
        '',
        'af_chargeReturn_number_nonInput',
      ],
      [
        'ESPI',
        'Early Settlement Payment Int',
        '',
        '',
        '',
        'espi_chargeReturnPerc_number',
        'espi_quantity_number',
        'espi_average_number_nonInput',
        'espi_chargeReturn_number_nonInput',
      ],
      [
        'FI',
        'Freight Inland',
        '',
        '',
        '',
        'fi_chargeReturnPerc_number',
        'fi_quantity_number',
        '',
        'fi_chargeReturn_number_nonInput',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'Total Charges ($)',
        'totalCharges_number_nonInput',
      ],
      [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'Total Settlement Amt ($)',
        'totalSettlementAmount_number_nonInput',
      ],
    ],
  };

  const formatValue = (value) => {
    if (value == null || isNaN(value)) return '0';
    const truncated = Math.trunc(value * 1000) / 1000;
    return truncated % 1 === 0 ? String(truncated) : truncated.toString();
  };

  const metalMap = {
    ptMetalReturn: 'ptOz',
    pdMetalReturn: 'pdOz',
    rhMetalReturn: 'rhOz',
  };

  const getMetalData = (metal, type) => {
    const ozPrice = loadData?.lotTableData?.[0]?.[`${metal}Oz`] || 0.0;
    const avgPrice = calculateWeightedAverage(
      loadData?.hedgeTableData,
      metalMap[`${metal}MetalReturn`],
      metalMap[`${metal}MetalReturn`] === 'ptOz'
        ? 'ptUnitPrice'
        : metalMap[`${metal}MetalReturn`] === 'pdOz'
        ? 'pdUnitPrice'
        : 'rhUnitPrice'
    );
    const chargeReturnPerc =
      product?.[`${metal}MetalReturn`]?.chargeReturnPerc || 0.0;
    return formatValue(avgPrice) * formatValue(ozPrice * chargeReturnPerc);
  };

  const getRefiningCharges = (metals) => {
    const refiningChargeMap = {
      ptRefiningCharge: 'ptOz',
      pdRefiningCharge: 'pdOz',
      rhRefiningCharge: 'rhOz',
    };
    return metals.reduce((sum, metal) => {
      const quantity = product?.[metal]?.quantity || 0.0;
      const chargeReturnPerc = product?.[metal]?.chargeReturnPerc || 0.0;
      let chargeReturn = 0.0;
      if (metal === 'intInvoice') {
        const advChargeReturn = product?.['advInvoice']?.chargeReturn || 0.0;
        chargeReturn =
          (chargeReturnPerc / 100 / 360) * quantity * advChargeReturn;
      } else if (metal === 'advInvoice') {
        chargeReturn = product?.[metal]?.chargeReturn || 0.0;
      } else if (
        metal === 'ptRefiningCharge' ||
        metal === 'pdRefiningCharge' ||
        metal === 'rhRefiningCharge'
      ) {
        const metalKeyOz =
          loadData?.lotTableData?.[0]?.[
            metalMap[
              metal === 'ptRefiningCharge'
                ? 'ptMetalReturn'
                : metal === 'pdRefiningCharge'
                ? 'pdMetalReturn'
                : 'rhMetalReturn'
            ]
          ] || 0.0;

        const metalKeyChargeReturnPerc =
          product?.[
            metal === 'ptRefiningCharge'
              ? 'ptMetalReturn'
              : metal === 'pdRefiningCharge'
              ? 'pdMetalReturn'
              : 'rhMetalReturn'
          ]?.chargeReturnPerc || 0.0;
        const chargeReturnPerc = product?.[metal]?.chargeReturnPerc || 0.0;
        chargeReturn = formatValue(
          chargeReturnPerc * formatValue(metalKeyOz * metalKeyChargeReturnPerc)
        );
      } else if (metal === 'espi') {
        const quantity = product?.[metal]?.quantity || 0.0;
        const chargeReturnPerc =
          (product?.[metal]?.chargeReturnPerc || 0.0) / 100 / 360;
        const metals = ['pt', 'pd', 'rh'];
        const metalReturnTotal = metals.reduce(
          (sumTotal, metalkey) =>
            sumTotal + getMetalData(metalkey, 'MetalReturn'),
          0
        );
        const espiAverage = getRefiningCharges([
          'ptRefiningCharge',
          'pdRefiningCharge',
          'rhRefiningCharge',
          'advInvoice',
          'intInvoice',
          'tc',
        ]);
        const finalEspiAverage = metalReturnTotal - espiAverage;
        chargeReturn = chargeReturnPerc * quantity * finalEspiAverage;
      } else {
        chargeReturn = chargeReturnPerc * quantity;
      }
      return sum + parseFloat(formatValue(chargeReturn));
    }, 0);
  };

  const handleSpecialCases = (metalKey) => {
    const refiningCharges = getRefiningCharges([
      'ptRefiningCharge',
      'pdRefiningCharge',
      'rhRefiningCharge',
      'advInvoice',
      'intInvoice',
      'tc',
      'sc',
      'af',
      'espi',
      'fi',
    ]);

    if (metalKey === 'totalCharges') {
      return ' - ' + formatValue(refiningCharges);
    }

    if (metalKey === 'totalSettlementAmount') {
      const metalReturn = ['pt', 'pd', 'rh'].reduce(
        (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
        0
      );
      return formatValue(metalReturn - refiningCharges);
    }

    return '';
  };

  const refiningChargeMap = {
    ptRefiningCharge: 'ptOz',
    pdRefiningCharge: 'pdOz',
    rhRefiningCharge: 'rhOz',
  };

  const refiningMap = ['intInvoice', 'tc', 'sc', 'af', 'espi', 'fi'];

  const calculateWeightedAverage = (data, ozKey, priceKey) => {
    let totalOz = 0;
    let totalValue = 0;

    data.forEach((entry) => {
      if (entry[ozKey] && entry[priceKey]) {
        totalOz += entry[ozKey];
        totalValue += entry[ozKey] * entry[priceKey];
      }
    });

    return totalOz > 0 ? (totalValue / totalOz).toFixed(2) : 0.0;
  };

  const getValueFromProduct = (keyParts, product) => {
    const [metalKey, keyValue] = keyParts;

    if (metalKey === 'totalCharges' || metalKey === 'totalSettlementAmount') {
      return handleSpecialCases(metalKey);
    }

    if (metalMap[metalKey] && keyValue === 'totalOunces') {
      const totalOunces =
        loadData?.lotTableData?.[0]?.[metalMap[metalKey]] || 0.0;
      return formatValue(parseFloat(totalOunces));
    }

    if (
      metalMap[metalKey] &&
      (keyValue === 'quantity' || keyValue === 'chargeReturn')
    ) {
      const oz = loadData?.lotTableData?.[0]?.[metalMap[metalKey]] || 0.0;
      const avgPrice = calculateWeightedAverage(
        loadData?.hedgeTableData,
        metalMap[metalKey],
        metalMap[metalKey] === 'ptOz'
          ? 'ptUnitPrice'
          : metalMap[metalKey] === 'pdOz'
          ? 'pdUnitPrice'
          : 'rhUnitPrice'
      );
      const chargeReturnPerc = product?.[metalKey]?.chargeReturnPerc || 0.0;

      return keyValue === 'quantity'
        ? formatValue(oz * chargeReturnPerc)
        : formatValue(
            formatValue(avgPrice) * formatValue(oz * chargeReturnPerc)
          );
    }

    if (metalMap[metalKey] && keyValue === 'avgPrice') {
      const avgPrice = calculateWeightedAverage(
        loadData?.hedgeTableData,
        metalMap[metalKey],
        metalMap[metalKey] === 'ptOz'
          ? 'ptUnitPrice'
          : metalMap[metalKey] === 'pdOz'
          ? 'pdUnitPrice'
          : 'rhUnitPrice'
      );
      return formatValue(avgPrice);
    }

    if (
      refiningChargeMap[metalKey] &&
      (keyValue === 'quantity' || keyValue === 'chargeReturn')
    ) {
      const metalKeyOz =
        loadData?.lotTableData?.[0]?.[
          metalMap[
            metalKey === 'ptRefiningCharge'
              ? 'ptMetalReturn'
              : metalKey === 'pdRefiningCharge'
              ? 'pdMetalReturn'
              : 'rhMetalReturn'
          ]
        ] || 0.0;

      const chargeReturnPerc = product?.[metalKey]?.chargeReturnPerc || 0.0;
      const metalKeyChargeReturnPerc =
        product?.[
          metalKey === 'ptRefiningCharge'
            ? 'ptMetalReturn'
            : metalKey === 'pdRefiningCharge'
            ? 'pdMetalReturn'
            : 'rhMetalReturn'
        ]?.chargeReturnPerc || 0.0;
      return keyValue === 'quantity'
        ? formatValue(metalKeyOz * metalKeyChargeReturnPerc)
        : '-' +
            formatValue(
              chargeReturnPerc *
                formatValue(metalKeyOz * metalKeyChargeReturnPerc)
            );
    }

    if (refiningMap.includes(metalKey) && keyValue === 'chargeReturn') {
      if (metalKey !== 'intInvoice' && metalKey !== 'espi') {
        const quantity = product?.[metalKey]?.quantity || 0.0;
        const chargeReturnPerc = product?.[metalKey]?.chargeReturnPerc || 0.0;
        return '-' + formatValue(chargeReturnPerc * quantity);
      } else if (metalKey === 'intInvoice') {
        const quantity = product?.[metalKey]?.quantity || 0.0;
        const chargeReturnPerc =
          (product?.[metalKey]?.chargeReturnPerc || 0.0) / 100 / 360;
        const advChargeReturn = product?.['advInvoice']?.chargeReturn || 0.0;
        return '-' + formatValue(chargeReturnPerc * quantity * advChargeReturn);
      } else if (metalKey === 'espi') {
        const quantity = product?.[metalKey]?.quantity || 0.0;
        const chargeReturnPerc =
          (product?.[metalKey]?.chargeReturnPerc || 0.0) / 100 / 360;
        const metals = ['pt', 'pd', 'rh'];
        const metalReturnTotal = metals.reduce(
          (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
          0
        );
        const espiAverage = getRefiningCharges([
          'ptRefiningCharge',
          'pdRefiningCharge',
          'rhRefiningCharge',
          'advInvoice',
          'intInvoice',
          'tc',
        ]);
        const finalEspiAverage = formatValue(metalReturnTotal - espiAverage);
        return (
          '-' + formatValue(chargeReturnPerc * quantity * finalEspiAverage)
        );
      }
    }

    if (metalKey === 'espi' && keyValue === 'average') {
      const refiningCharges = getRefiningCharges([
        'ptRefiningCharge',
        'pdRefiningCharge',
        'rhRefiningCharge',
        'advInvoice',
        'intInvoice',
        'tc',
      ]);
      const metals = ['pt', 'pd', 'rh'];
      const metalReturnTotal = metals.reduce(
        (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
        0
      );
      return formatValue(formatValue(metalReturnTotal) - refiningCharges);
    }

    if (metalKey === 'metalReturn') {
      const metals = ['pt', 'pd', 'rh'];
      const total = metals.reduce(
        (sum, metal) => sum + getMetalData(metal, 'MetalReturn'),
        0
      );
      return formatValue(total);
    }

    return product[metalKey]?.[keyValue] ?? '';
  };

  const getDateValueFromProduct = (keyParts, product) => {
    if (keyParts.length === 3) {
      const productDate = product?.[keyParts[0]]?.[keyParts[1]]
        ? new Date(product?.[keyParts[0]]?.[keyParts[1]])
        : '';
      return productDate !== ''
        ? `${String(productDate.getMonth() + 1).padStart(2, '0')}-${String(
            productDate.getDate()
          ).padStart(2, '0')}-${productDate.getFullYear()}`
        : '';
    }
    const productDate = product?.[keyParts[0]]
      ? new Date(product?.[keyParts[0]])
      : '';
    return product?.[keyParts[0]]
      ? `${String(productDate.getMonth() + 1).padStart(2, '0')}-${String(
          productDate.getDate()
        ).padStart(2, '0')}-${productDate.getFullYear()}`
      : '';
  };

  return (
    <div className='pdf-invoice' id='pdfDiv'>
      <div className='flex flex-middle flex-between'>
        <div className='flex-middle'>
          <h1 className='mr-24 fs-18 c-gray'>
            <button
              type='button'
              onClick={() => {
                ref.save();
              }}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: '#0d6efd',
                textDecoration: 'underline',
                cursor: 'pointer',
                font: 'inherit',
              }}
            >
              Export PDF
            </button>
          </h1>
          <ReactToPrint
            trigger={() => {
              return (
                <button
                  type='button'
                  className='fs-18 c-gray'
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    color: '#0d6efd',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    font: 'inherit',
                  }}
                >
                  Print
                </button>
              );
            }}
            content={() => componentRef}
          />
        </div>
        <div>
          <h1
            className='mr-24 fs-24 c-gray mb-4'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              props.setPrintPopup({});
            }}
          >
            {' '}
            X{' '}
          </h1>
        </div>
      </div>
      <PDFExport
        fileName={`${loadData?.settlementId || 'Settlement'}.pdf`}
        forcePageBreak='.page-break'
        scale={0.6}
        paperSize='A4'
        margin='1cm'
        ref={(component) => (ref = component)}
      >
        <div
          ref={(el) => (componentRef = el)} //ref={ref}
          className='k-grid'
          style={{
            margin: '0 auto',
            padding: '1mm',
          }}
        >
          <div className='flex flex-middle flex-between flex-column'>
            <div className='flex justify-center'>
              <div style={{ fontWeight: 'bold', fontSize: 12 }}>
                SETTLEMENT STATEMENT
              </div>
            </div>
            <div className='d-flex w-100 p-4'>
              <div className='w-50'>
                <div>
                  <img
                    src={Logo1}
                    style={{ width: 100 }}
                    className='mb-4 sidebar-logo'
                  />
                </div>
                <div style={{ fontWeight: 'bold', fontSize: 10 }}>
                  Prepared By:
                </div>
                <div className='fs-10'>A & B Converters</div>
                <div className='fs-10'>dba AB CATTECH</div>
                <div className='fs-10'>688 Maryland Avenue</div>
                <div className='fs-10'>Burlington, WI 53105</div>
                <div className='fs-10'>United States</div>
              </div>
              <div className='w-50' style={{ alignContent: 'center' }}>
              <div style={{ fontWeight: 'bold', fontSize: 10 }}>
                  Prepared For:
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Customer Name: {loadData?.companyName}
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Location: {loadData?.facilityCity}
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Settlement No: {loadData?.settlementNo}
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Contract No: {loadData?.contractNo}
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Shipment No: {loadData?.shipmentNo}
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Received Date:{' '}
                  {`${String(receivedDate.getMonth() + 1).padStart(
                    2,
                    '0'
                  )}-${String(receivedDate.getDate()).padStart(
                    2,
                    '0'
                  )}-${receivedDate.getFullYear()}`}
                </div>
                <div style={{ fontWeight: 'normal', fontSize: 10 }}>
                  Metal Due Date:{' '}
                  {`${String(metalDueDate.getMonth() + 1).padStart(
                    2,
                    '0'
                  )}-${String(metalDueDate.getDate()).padStart(
                    2,
                    '0'
                  )}-${metalDueDate.getFullYear()}`}
                </div>
              </div>
            </div>

            {/* Shipping Docs */}

            <div
              className='flex flex-wrap gap-2 justify-between'
              style={{ width: '100%' }}
            >
              <div className='flex-1 min-w-[300px]'>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 10,
                    textAlign: 'center',
                    marginBottom: 8,
                  }}
                >
                  Shipping Docs
                </div>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={cellStyle}></th>
                      <th style={cellStyle}>Units</th>
                      <th style={cellStyle}>LM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        title: 'Gross',
                        value: loadData?.shippingDocs?.gross,
                      },
                      {
                        title: 'Tare',
                        value: loadData?.shippingDocs?.tare,
                      },
                      {
                        title: 'Net',
                        value: loadData?.shippingDocs?.net,
                      },
                      {
                        title: 'Total Net',
                        value: loadData?.shippingDocs?.total,
                      },
                    ].map((data, index) => {
                      return (
                        <tr index={index}>
                          <td style={cellStyle}>{data.title}</td>
                          <td style={cellStyle}></td>
                          <td style={cellStyle}>{data.value}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* MMI Received */}

              <div className='flex-1 min-w-[300px] '>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 10,
                    textAlign: 'center',
                    marginBottom: 8,
                  }}
                >
                  AB Received
                </div>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={cellStyle}></th>
                      <th style={cellStyle}>Units</th>
                      <th style={cellStyle}>LM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        title: 'Gross',
                        value: loadData?.mmiReceived?.gross,
                      },
                      {
                        title: 'Tare',
                        value: loadData?.mmiReceived?.tare,
                      },
                      {
                        title: 'Net',
                        value: loadData?.mmiReceived?.net,
                      },
                      {
                        title: 'Total Net',
                        value: loadData?.mmiReceived?.total,
                      },
                    ].map((data, index) => {
                      return (
                        <tr index={index}>
                          <td style={cellStyle}>{data.title}</td>
                          <td style={cellStyle}></td>
                          <td style={cellStyle}>{data.value}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* MMI Processed */}

              <div className='flex-1 min-w-[300px] '>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 10,
                    textAlign: 'center',
                    marginBottom: 8,
                  }}
                >
                  AB Processed
                </div>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={cellStyle}></th>
                      <th style={cellStyle}>Units</th>
                      <th style={cellStyle}>LM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        title: 'Mono / WC',
                        value: loadData?.mmiProcessed?.monoNet,
                        value1: loadData?.mmiProcessed?.monoDry,
                      },
                      {
                        title: 'BHD',
                        value: loadData?.mmiProcessed?.bhdNet,
                        value1: loadData?.mmiProcessed?.bhdDry,
                      },
                      {
                        title: 'Samples',
                        value: loadData?.mmiProcessed?.samplesNet,
                        value1: loadData?.mmiProcessed?.samplesDry,
                      },
                      {
                        title: 'Trash',
                        value: loadData?.mmiProcessed?.trashNet,
                        value1: loadData?.mmiProcessed?.trashDry,
                      },
                      {
                        title: 'Magnetics',
                        value: loadData?.mmiProcessed?.magneticsNet,
                        value1: loadData?.mmiProcessed?.magneticsDry,
                      },
                      {
                        title: 'Total Processed',
                        value: loadData?.mmiProcessed?.totalProcessedNet,
                        value1: loadData?.mmiProcessed?.totalProcessedDry,
                      },
                    ].map((data, index) => {
                      return (
                        <tr index={index}>
                          <td style={cellStyle}>{data.title}</td>
                          <td style={cellStyle}>{data.value}</td>
                          <td style={cellStyle}>{data.value1}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Hedge */}
              {loadData?.hedgeTableData?.length > 0 && (
                <div className='flex flex-column' style={{ width: '100%' }}>
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: 10,
                      textAlign: 'left',
                      marginBottom: 8,
                    }}
                  >
                    Hedge
                  </div>
                  <div>
                    <table
                      style={{ borderCollapse: 'collapse', width: '100%' }}
                    >
                      <thead>
                        <tr>
                          <th style={cellStyle}>Hedge No</th>
                          <th style={cellStyle}>Hedge Date</th>
                          <th style={cellStyle}>PT Oz</th>
                          <th style={cellStyle}>PT Unit Price</th>
                          <th style={cellStyle}>PD Oz</th>
                          <th style={cellStyle}>PD Unit Price</th>
                          <th style={cellStyle}>RH Oz</th>
                          <th style={cellStyle}>RH Unit Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(loadData?.hedgeTableData || []).map(
                          (hedge, index) => {
                            const hedgeDate = new Date(hedge.hedgeDate);
                            return (
                              <>
                                <tr index={index}>
                                  <td style={cellStyle}>{hedge.hedgeNo}</td>
                                  <td style={cellStyle}>{`${String(
                                    hedgeDate.getMonth() + 1
                                  ).padStart(2, '0')}-${String(
                                    hedgeDate.getDate()
                                  ).padStart(
                                    2,
                                    '0'
                                  )}-${hedgeDate.getFullYear()}`}</td>
                                  <td style={cellStyle}>{hedge.ptOz}</td>
                                  <td style={cellStyle}>{hedge.ptUnitPrice}</td>
                                  <td style={cellStyle}>{hedge.pdOz}</td>
                                  <td style={cellStyle}>{hedge.pdUnitPrice}</td>
                                  <td style={cellStyle}>{hedge.rhOz}</td>
                                  <td style={cellStyle}>{hedge.rhUnitPrice}</td>
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Lot */}
              {loadData?.lotTableData?.length > 0 && (
                <div className='flex flex-column' style={{ width: '100%' }}>
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: 10,
                      textAlign: 'left',
                      marginBottom: 8,
                    }}
                  >
                    Lot
                  </div>
                  <div>
                    <table
                      style={{ borderCollapse: 'collapse', width: '100%' }}
                    >
                      <thead>
                        <tr>
                          <th style={cellStyle}>Lot No</th>
                          <th style={cellStyle}>Sample No</th>
                          <th style={cellStyle}>H2O %</th>
                          <th style={cellStyle}>Net Dry</th>
                          <th style={cellStyle}>Sample Dry</th>
                          <th style={cellStyle}>PT PPM</th>
                          <th style={cellStyle}>PT Oz</th>
                          <th style={cellStyle}>PD PPM</th>
                          <th style={cellStyle}>PD Oz</th>
                          <th style={cellStyle}>RH PPM</th>
                          <th style={cellStyle}>RH Oz</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(loadData?.lotTableData || []).map(
                          (lotData, index) => {
                            return (
                              <>
                                <tr index={index}>
                                  <td style={cellStyle}>{lotData.lotNo}</td>
                                  <td style={cellStyle}>{lotData.sampleNo}</td>
                                  <td style={cellStyle}>{lotData.h20}</td>
                                  <td style={cellStyle}>{lotData.netDry}</td>
                                  <td style={cellStyle}>{lotData.sampleDry}</td>
                                  <td style={cellStyle}>{lotData.ptPpm}</td>
                                  <td style={cellStyle}>{lotData.ptOz}</td>
                                  <td style={cellStyle}>{lotData.pdPpm}</td>
                                  <td style={cellStyle}>{lotData.pdOz}</td>
                                  <td style={cellStyle}>{lotData.rhPpm}</td>
                                  <td style={cellStyle}>{lotData.rhOz}</td>
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Product */}

              <div className='flex flex-column' style={{ width: '100%' }}>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 10,
                    textAlign: 'left',
                    marginBottom: 8,
                  }}
                >
                  Product
                </div>
                <div>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        {productData &&
                          productData.header &&
                          productData.header.map((value, index) => {
                            return (
                              <th key={index} style={cellStyle}>
                                {value}
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody>
                      {(productData.data || []).map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {(row || []).map((cell, colIndex) => {
                            if (!cell) {
                              return <td key={colIndex} style={cellStyle}></td>;
                            }

                            const keyParts = cell.split('_');
                            const isInput = keyParts.length > 1;
                            const isNonInput = keyParts[2] === 'nonInput';
                            const metalKey = keyParts[1];

                            let content;

                            if (isInput) {
                              content = cell.endsWith('_date') ? (
                                getDateValueFromProduct(keyParts, product)
                              ) : metalKey === 'chargeReturn' || isNonInput ? (
                                <div
                                  style={{ fontSize: 10, fontWeight: 'bolder' }}
                                >
                                  <CurrencyFormat
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={''}
                                    value={getValueFromProduct(
                                      keyParts,
                                      product
                                    )}
                                  />
                                </div>
                              ) : (
                                <div style={{ fontSize: 10 }}>
                                  <CurrencyFormat
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={''}
                                    value={getValueFromProduct(
                                      keyParts,
                                      product
                                    )}
                                  />
                                </div>
                              );
                            } else {
                              content = (
                                <div
                                  style={{
                                    fontWeight:
                                      cell === 'Metal Return Value ($)' ||
                                      cell === 'Total Charges ($)' ||
                                      cell === 'Total Settlement Amt ($)'
                                        ? 'bolder'
                                        : 'normal',
                                  }}
                                >
                                  <span>{cell}</span>
                                </div>
                              );
                            }

                            return (
                              <td key={colIndex} style={cellStyle}>
                                <span>{content}</span>
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PDFExport>
    </div>
  );
};

export default SettlementPDF;
